import { useState, useEffect } from 'react';
import { InputTextCustom, WindowLoader } from 'medere-ui-framework';
import GeneralRecipeViewCard from '../../Components/GeneralRecipeViewCard';
import './PatientAgendaView.scss';
import { Icon } from '@iconify/react';
import { PatientRecordDTO } from '../../../../interface/interface';
import { getPatientsInfo } from '../../../../services/digitalRPservice';

const PatientAgendaView = ({setSelectedPatient, onCreatePatient }: {setSelectedPatient: (patient: PatientRecordDTO) => void, onCreatePatient: () => void}) => {

    const [patientInput, setPatientInput] = useState('');
    const [activeCard, setActiveCard] = useState<number | null>(null);
    const [patientList, setPatientList] = useState<PatientRecordDTO[]>([])

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getListOfPatients = async () => {
            setLoading(true)
            const pList: PatientRecordDTO[] = await getPatientsInfo(patientInput, 500, 0)
                                              .then((res:PatientRecordDTO[]) => {
                                                  return res
                                              })
                                              .catch((error:any) => {
                                                  console.error('Error: ', error); 
                                                  return [];
                                             });
            setPatientList(pList);
            setLoading(false)
        };

        getListOfPatients();
    }, [, patientInput]);

    return (
        <div className="patient-agenda-view">
            <h1 style={{marginTop:'8px', fontWeight:600}}>Agenda de pacientes</h1>
            <div style={{textAlign:'right', marginBottom:'10px'}}>
                <button onClick={onCreatePatient}>
                    <Icon icon='bi:person-plus-fill' style={{ fontSize: '34px', padding: '8px', backgroundColor: '#DBDFE5', borderRadius: '100%' }} />
                </button>
            </div>
            <div style={{ marginBottom: '30px', marginTop: '-8px' }} className="patient-search-container"> 
                <InputTextCustom
                    className={`patient-input ${patientInput ? 'active' : ''} border-grey`}
                    value={patientInput}
                    onChange={(e) => setPatientInput(e.target.value)}
                    placeholder="Buscar por apellido, nombre o DNI"
                />
                <i className="pi pi-search patient-search-icon"></i>
                <div className='gap-2' style={{display:'flex', flexDirection:'row'}}>
                    <i className="pi pi-qrcode"></i>
                    <button type='button' className='linkRp link-action-button' style={{ color: '#3CB8BA', fontFamily:'sans-serif', background:'none', border:'none', padding:0, cursor:'pointer' }}>Link para agendarse</button>
                </div>
            </div>
            <div className='cards-container-patient-agenda'>
                {patientList && patientList.length > 0 ? 
                    patientList.map((patient:PatientRecordDTO, index) => (
                        <GeneralRecipeViewCard
                            key={index}
                            title={<label style={{fontWeight:600}}>{patient.firstname+" "+patient.lastname}</label>}
                            detail={"DNI: "+patient.document}
                            detail2={<div style={{display:'flex', flexDirection:'column'}}><p>{"Afiliado: "+patient.insurances?.find(insurance => insurance.primarycoverage)?.benefitnumber}</p><p>{patient.insurances?.find(insurance => insurance.primarycoverage)?.healthentityplan.healthentity.commercialname+", "+patient.insurances?.find(insurance => insurance.primarycoverage)?.healthentityplan.name}</p></div>}
                            onClick={() => {
                                setActiveCard(index);
                                setTimeout(() => {
                                    setSelectedPatient(patient);
                                    setActiveCard(null);
                                }, 100);
                            }}
                            backgroundColor='#F3F5F7'
                            titleColor='#009688'
                            border='1px solid #A9B1BC'
                            borderRadius='8px'
                            changeColorIfActive={activeCard === index}
                        />
                    ))
                    :
                    <p style={{ color: '#000000', fontSize: '14px', fontFamily: 'sans-serif', fontStyle: 'italic' }}>{"Todavía no se han encontrado resultados"}</p>
                }
            </div>

            <WindowLoader showLoader={loading} className='whiteSpinner'/>
        </div>
    );
};

export default PatientAgendaView;
